import ThinkSeedCreation from './container';

export default ThinkSeedCreation;



// WEBPACK FOOTER //
// ./src/routes/ThinkSeedCreation/index.js